
import Experience from './Experience/Experience.js'

const experience = new Experience(document.querySelector('canvas.webgl'))

